// Invoices and payments.
import { createRoute } from "@tanstack/react-router";
import { InvoicesList } from "../../screens/invoices/List";
import { InvoicePage } from "../../screens/invoices/Page";
import { PaymentPage, PaymentsPage } from "../../screens/Payments";
import { SectionMessages } from "../../screens/settings/Automations";
import { FeatureSettings } from "../../screens/settings/Feature";
import { MoneySettings } from "../../screens/settings/Money";
import { Allowed, app, newSearch, page, sectionMessagePage } from "./base";

const invoicesList = createRoute({
  getParentRoute: () => app,
  path: "/invoices",
  // clientId: the client page's + opens the new invoice box with that client picked.
  validateSearch: (s: Record<string, unknown>): { new?: boolean; clientId?: string } => ({
    ...newSearch(s),
    ...(typeof s.clientId === "string" && s.clientId ? { clientId: s.clientId } : {}),
  }),
  component: () => (
    <Allowed action="invoice.read">
      <InvoicesList />
    </Allowed>
  ),
});

// Invoices, payments, quotes and leads (draft 3).
const invoicePage = createRoute({
  getParentRoute: () => app,
  path: "/invoices/$id",
  /** then=send opens the Send box on arrival (New invoice's Save and send). */
  validateSearch: (s: Record<string, unknown>): { then?: "send" } => (s.then === "send" ? { then: "send" } : {}),
  component: function InvoiceRoute() {
    const { id } = invoicePage.useParams();
    const { then } = invoicePage.useSearch();
    return (
      <Allowed action="invoice.read">
        <InvoicePage key={id} id={id} {...(then ? { then } : {})} />
      </Allowed>
    );
  },
});

const paymentPage = createRoute({
  getParentRoute: () => app,
  path: "/payments/$id",
  component: function PaymentRoute() {
    const { id } = paymentPage.useParams();
    return (
      <Allowed action="invoice.read">
        <PaymentPage key={id} id={id} />
      </Allowed>
    );
  },
});

export const moneyRoutes = [
  // Settings that live with their feature (2026-10-29); the old Settings addresses below still land here.
  page("/invoices/settings", () => (
    <Allowed action="settings.read">
      <FeatureSettings title="Invoice and payment settings" back="/invoices" backLabel="All invoices">
        <SectionMessages section="invoices" />
        <MoneySettings />
      </FeatureSettings>
    </Allowed>
  )),
  invoicesList,
  invoicePage,
  page("/payments", () => (
    <Allowed action="invoice.read">
      <PaymentsPage />
    </Allowed>
  )),
  paymentPage,
  sectionMessagePage("/invoices/settings/messages/$kind", "invoices"),
] as const;
